import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Link } from "react-router-dom";

const Cancel = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        minHeight: "100vh",
      }}
    >
      <div style={{ marginTop: "25vh", textAlign: "center", padding: "20px" }}>
        <ErrorOutlineIcon
          style={{ fontSize: "80px", color: "#f44336", marginBottom: "10px" }}
        />
        <Typography variant="h5" style={{ marginBottom: "10px" }}>
          Payment Canceled
        </Typography>
        <Typography variant="body1" style={{ marginBottom: "20px" }}>
          Your payment has been canceled. Please try again later or contact
          support.
        </Typography>
        <Link to={'/user/dashboard'}>
          <Button
            variant="contained"
            color="primary"
            style={{ marginTop: "20px" }}
          >
            Return to Homepage
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Cancel;
